import { Component, OnInit, ViewChild } from "@angular/core";
import { IonContent } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { gsap } from 'gsap';
//Paid plugin added. Do not comment below plugins. You just need to remove node_modules and have to do npm i again.
import { MotionPathHelper } from 'gsap/MotionPathHelper'; // Import the MotionPathPlugin
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { AudioService } from "src/app/services/audio/audio.service";
gsap.registerPlugin(MotionPathHelper, MotionPathPlugin); // Register the MotionPathPlugin

@Component({
	selector: 'app-piggy-bank-tutorial',
	templateUrl: './piggy-bank-tutorial.component.html',
	styleUrls: ['./piggy-bank-tutorial.component.scss'],
})

export class PiggyBankTutorialComponent implements OnInit {
	isBoydMember:boolean;
	@ViewChild(IonContent, { static: false }) content: IonContent;
	skippedFrom: string;
	slideNumber = 1;
	up2xpopup = false;
	openCancelFlag = false;
	animationFlag = false;

	constructor(
		public navigator:Navigator,
		public authenticationService: AuthenticationService,
		public userSessionService: UserSessionService,
		private audioService: AudioService,
		private utils:UtilsService
	) { 
		this.animateFlash();
	}


	ngOnInit(): void {
		setTimeout(() => {
			if(this.slideNumber == 1) {
				this.nextStep(2);
			}
		}, 6000);
	}

	public nextStep(stepNumber) {

		if(this.animationFlag) 
		{
			stepNumber++;
			this.animationFlag = false;
		}
		this.slideNumber = stepNumber;
		this.audioService.playSound("SettingsOpen");
		setTimeout(() => {
			this.audioService.playSound("PiggyBankOpen")
		}, 1000);
		this.animateArrow();
		if(stepNumber == 1) {
			this.animateFlash();
		} else if(stepNumber == 5) {
			this.animatePopUp();
			this.animationFlag = true;
		} else if(stepNumber == 8) {
			return this.navigator.navigateTo('PiggyBankComponent', { customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true });
		}
	}

	public onClose() {
		this.audioService.playSound("SettingsOpen");
		this.navigator.dismissAll();
	}

	public animateArrow() {
		//adding small delay before animation for view to render properly
		setTimeout(()=> {
			gsap.to(".arrow",{
				xPercent:-25,
				repeat: -1,
				yoyo: true,
				duration: 0.9,
				ease:'power3.inOut'
			})
		}, 10);
		
	}

	animateFlash() {
		//adding small delay before animation for view to render properly
		setTimeout(()=> {
			gsap.to(".bg-flash",{
				rotation: 360,
				repeat: -1,
				duration: 5,
				ease:'none'
			});
			gsap.to(".bg-flash-reverse",{
				rotation: -360,
				repeat: -1,
				duration: 5,
				ease:'none'
			});
		}, 10);
	}

	animatePopUp() {
		setTimeout(()=> {
			gsap.fromTo(".overlay-2x", 
			{ opacity: 0 }, 
			{ opacity: 1, duration: 0.3 });
		}, 10);
		setTimeout(()=> {
			gsap.fromTo(".overlay-2x", 
			{ opacity: 1 }, 
			{ opacity: 0, duration: 0.3 });
		}, 3000);
	}

	

	openCancel = () => {
		this.audioService.playSound("SettingsOpen");
		this.openCancelFlag = true;
	}

	closeCancel() {
		this.audioService.playSound("SettingsOpen");
		this.openCancelFlag = false;
		this.nextStep(this.slideNumber);
	}
}
	
